import http from '@/requests/http'

class Database {
  static findAll (params) {
    return http.post('servers/databases', params)
  }
  static store (params) {
    return http.post('servers/databases/store', params)
  }
  static view (params) {
    return http.post('servers/databases/view', params)
  }
  static update (params) {
    return http.post('servers/databases/update', params)
  }
  static destroy (params) {
    return http.post('servers/databases/destroy', params)
  }
}

export default Database
